/**
 * @generated SignedSource<<a5d61ac99021e97b35f7b304f7693803>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SheetRendererNote_note$data = {
  readonly bulb_id: string;
  readonly sheet_id: string;
  readonly boxes: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"SheetRendererNoteBox_box">;
  }>;
  readonly " $fragmentType": "SheetRendererNote_note";
};
export type SheetRendererNote_note$key = {
  readonly " $data"?: SheetRendererNote_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"SheetRendererNote_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SheetRendererNote_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bulb_id",
      "storageKey": null
    },
    {
      "alias": "sheet_id",
      "args": null,
      "kind": "ScalarField",
      "name": "page_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Box",
      "kind": "LinkedField",
      "name": "boxes",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SheetRendererNoteBox_box"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MusicPieceFileNote",
  "abstractKey": null
};

(node as any).hash = "e884a41fd20378072f40762d221076a7";

export default node;
